// extracted by mini-css-extract-plugin
export default {"graphCard":"GraphCard_graphCard__d7OP1","icon":"GraphCard_icon__58C2U"};